export const services = [
  {
    id: 1,
    title: "Heavy-Duty Warehouse Racking",
    description: "Warehouse shelving products",
    image: "/assets/images/1.jpeg",
  },
  {
    id: 2,
    title: "Supermarket Solutions",
    description: "Supermarket shelving products",
    image: "/assets/images/5.jpeg",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "محمد الراشد",
    role: "مدير مستودعات",
    company: "شركة لوجستية كبرى",
    text: "قدمت الشركة أنظمة رفوف ثقيلة ممتازة لمستودعنا. التركيب كان سلساً والجودة فاقت توقعاتنا. أنصح بشدة أي عمل صناعي يحتاج حلول تخزين احترافية.",
    avatar: "م",
  },
  {
    id: 2,
    name: "فيصل العتيبي",
    role: "مدير عمليات",
    company: "مجموعة تجارية رائدة",
    text: "حوّلت رفوف التجزئة المخصصة تصميم متجرنا بشكل كامل. ارتفعت المبيعات بنسبة 25٪ بعد إعادة التصميم. فريقهم فهم رؤيتنا بشكل مثالي.",
    avatar: "ف",
  },
  {
    id: 3,
    name: "أحمد السعود",
    role: "مدير المشتريات",
    company: "سلسلة سوبر ماركت",
    text: "كان العمل مع الفريق في مشروع رفوف السوبر ماركت نقلة نوعية. الحلول متينة وقابلة للتخصيص ومثالية للبيئات ذات الحركة المكثفة.",
    avatar: "أ",
  },
  {
    id: 4,
    name: "خالد المطيري",
    role: "مدير منشآت",
    company: "شركة صناعية كبرى",
    text: "من الاستشارة الأولى حتى التركيب النهائي، كان الاحترافية في أعلى مستوياتها. زادت طاقة مستودعنا بنسبة 40٪ مع نظام الرفوف الجديد.",
    avatar: "خ",
  },
];